module.exports = __webpack_public_path__ + "img/ico-feature_2.0f71b3e5.svg";